import mapData from "lib/stores/mapData";
import apiData from "lib/stores/apiData";
import { ArcLayer } from "@deck.gl/layers";
import ArcSlinkyLayer from "./arcSlinkyLayer";
import { MapboxLayer } from "@deck.gl/mapbox";
import { easeOutBack, easeOutExpo, easeInExpo } from "lib/helpers/math";

// data: "https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_10m_airports.geojson",

const setArcLayer = (productsCountry, selectedProduct, activeYear, opacity, layer = "one") => {
  const getColor = () => {
    const category = mapData.activeCategory;
    if (productsCountry && selectedProduct) {
      switch (category) {
        case "prevalence":
          return [255, 92, 69, 255];
        case "vulnerability":
          return [126, 178, 226, 255];
        case "gov-response":
          return [255, 204, 43, 255];
        default:
          return [254, 92, 69, 0];
      }
    } else {
      return [254, 92, 69, 0];
    }
  };
  const getData = () => {
    const returnData = {
      type: "FeatureCollection",
      features: []
    };
    try {
      const data = apiData.countries[productsCountry];
      data.imports.forEach(d => {
        const exportingCountry = Object.keys(apiData.countries).find(country => {
          return apiData.countries[country].iso === d.exporter;
        });
        if (exportingCountry && d.product.toLowerCase().replaceAll(' ', '%20') === selectedProduct) {
          returnData.features.push({
            from: {
              coordinates: [apiData.countries[productsCountry].centroid.cx, apiData.countries[productsCountry].centroid.cy]
            },
            to: {
              coordinates: [apiData.countries[exportingCountry].centroid.cx, apiData.countries[exportingCountry].centroid.cy]
            }
          });
        }
      });

      return returnData.features;
    } catch (error) {
      return {
        type: "FeatureCollection",
        features: []
      };
    }
  };

  const data = JSON.parse(JSON.stringify(getData()));
  return new ArcLayer({
    id: `arcs-layer-${layer}`,
    data: data,
    getSourceColor: getColor(),
    getTargetColor: getColor(),
    getSourcePosition: d => {
      return d.from.coordinates;
    },
    getTargetPosition: d => {
      return d.to.coordinates;
    },
    getMinWidth: 2,
    getMaxWidth: 6,
    getWidth: 4,
    getHeight: 0.7,
    parameters: {
      depthTest: false
    },
    opacity,
    transitions: {
      opacity: {
        duration: opacity === 1.0 ? 750 : 0,
        easing: easeInExpo
      },
      getTargetColor: {
        duration: 1500,
        easing: easeOutExpo
      }
    },
    onHover: (info, event) => {
      try {
        mapData.hoveredCountry = info.properties.ISO_A3;
      } catch (error) {
        return;
      }
    },
    updateTriggers: {
      getTargetPosition: !selectedProduct ? false : data,
      data: !selectedProduct ? false : data,
      getSourcePosition: !selectedProduct ? false : data
    }
  });
};

export { setArcLayer };
